import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { ColumnContainer } from 'utils/columnsStyle';
import { useDispatch, useSelector } from 'react-redux';
import { useToggle } from 'hooks/useToggle';
import { Checkbox, FormControlLabel } from '@mui/material';
import { deleteFillingOrder } from 'redux/actions/fillingOrder/fillingOrderActions';
import { ModalV2 } from 'components/Modal/ModalV2';
import RegularButton from 'components/CustomButtons/Button';
import { deselectFillingOrderDelete } from 'redux/actions/fillingOrder/fillingOrderActions';
import { selectFillingOrderDelete } from 'redux/actions/fillingOrder/fillingOrderActions';

const style = {
  color: '#004F9F',
  fontSize: 20,
  marginRight: 10,
  cursor: 'pointer'
}

export const columns = [
  {
    Header: "N° Orden",
    accessor: "numberOrderExtra",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) =>
      row?.numberOrderExtra?.toString().toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Unidad",
    accessor: "unit",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) =>
      row.unit.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Tipo de llenado",
    accessor: "type",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) =>
      row.type.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "C. Autorización",
    accessor: "authorizationNumber",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) =>
      row.authorizationNumber.toString().toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Estación de Llenado",
    accessor: "fillingStation",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) =>
      row.fillingStation.toString().toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Estación Operativa",
    accessor: "operatingStation",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) =>
      row.operatingStation.toString().toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Estatus",
    accessor: "status",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) =>
      row.status.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => (<span style={{ 
        color: `${original.status === 'ERROR' && 'red'}`, 
        fontWeight: `${original.status === 'ERROR' && 'bold'}`
      }}>{ original.status }</span>)
  },
  {
    Header: "Fecha",
    accessor: "date",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) =>
      row.date.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Cantidad",
    accessor: "quantity",
    filterable: true,
    sortable: true,
    filterMethod: (filter, row) => 
      row.quantity.toLowerCase().includes(filter.value.toLowerCase()) || 
      row.measureUnit.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => `${original.quantity} ${original.measureUnit}`
  },
  {
    Header: "Acciones",
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch()
      const [isOpenDelete, handleIsOpenDelete] = useToggle();
      const { fillingOrdersToDelete } = useSelector(({ fillingOrder }) => fillingOrder)
      const { id, status } = original
      const isDeletable = fillingOrdersToDelete?.includes(id)
      
      const handleIsDelete = () => {
        if(isDeletable) dispatch(deselectFillingOrderDelete(id))
        else dispatch(selectFillingOrderDelete(id))
      }

      const handleDelete = () => {
        dispatch(deleteFillingOrder([id]))
        handleIsOpenDelete()
      }

      return (
        <>
          <ColumnContainer>
            <DeleteIcon style={{ ...style,  color: '#e83737'}} onClick={handleIsOpenDelete}/>
            <FormControlLabel
              control={<Checkbox 
              disabled={status !== 'PENDIENTE'}
              color='success' 
              checked={isDeletable} 
              onChange={handleIsDelete} 
              name='delete' 
              size='small'
              sx={{
                color: 'rgb(246,110,94)',
                '&.Mui-checked': {
                  color: 'rgb(98, 212, 102)',
                },
              }}
              tooltip='Eliminar'
            />}
            />
          </ColumnContainer>
          <ModalV2
            title={"Estas seguro de eliminar la orden?"}
            justConfirm
            open={isOpenDelete}
            onClose={handleIsOpenDelete}
            minHeight={2}
            textAlign="center"
            textMargin={28}
          >
            <RegularButton
              color="transparent"
              onClick={handleIsOpenDelete}
            >
              Cancelar
            </RegularButton>
            <RegularButton
              color="success"
              onClick={handleDelete}
            >
              Confirmar
            </RegularButton>
          </ModalV2>
        </>
      )
    },
  },
];
